module.exports = __webpack_public_path__ + "img/img92.6f92d81c.png";